import { FEEDBACK_ROUTES } from '../../constants/_routes'
import feedbackTypes from '../../constants/feedbackTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'
//
const get_feedback_questions_request = () => {
  return {
    type: feedbackTypes.get_questions.request
  }
}

const get_feedback_questions_success = (response) => {
  return {
    type: feedbackTypes.get_questions.success,
    payload: response.data
  }
}

const get_feedback_questions_failure = (messages) => {
  return {
    type: feedbackTypes.get_questions.failure,
    payload: messages
  }
}

const get_feedback_questions = () => {
  return function (dispatch) {
    // Before Request
    dispatch(get_feedback_questions_request())

    // Request
    axios.get(
      FEEDBACK_ROUTES.get_questions
    ).then( response => {
      // success
      dispatch( get_feedback_questions_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching feedback questions."]
      }
      dispatch( get_feedback_questions_failure(errors))
    })
  }

}

export {
  get_feedback_questions
}



// WEBPACK FOOTER //
// ./src/js/actions/feedback/get_questions.js